module.exports = {"id":"205193","name":"Karim Rekik","rating":"78","photo":"./data/images/photos/1/205193.png","club":{"name":"Hertha Berlin","logo":"./data/images/clubs/HerthaBerlin.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KarimRekik0.json
// module id = 2292
// module chunks = 0